import { useMutation } from '@tanstack/react-query';
import { instance } from '../../config/intercepter';
import usePersonStore from '../../store/personStore';
import { loginUserFn, logoutUserFn } from '../../transactions/user/user';
import { queryClient } from '../../utils/queryClient';
import { clearStoreage } from '../../utils/helper';
import { useToast } from '../../components/ui/Toast/useToast';

const useSignIn = () => {
  const { setAuthData } = usePersonStore();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (userData) => loginUserFn(userData),
    onSuccess: (data) => {
      if (data.exceptions.length > 0) {
        toast({
          variant: 'destructive',
          description: data.exceptions[0],
        });
      } else {
        const { access_token, token_type } = data?.data;
        instance.defaults.headers.common = {
          Authorization: `${token_type} ${access_token}`,
        };

        setAuthData(data.data);
        localStorage.setItem('jwt', access_token);
        localStorage.setItem('isLoggedIn', true);
      }
    },
    onError: (error) => {
      console.log('error', error);
      toast({
        variant: 'destructive',
        description: 'Παρουσιάστηκε κάποιο πρόβλημα',
      });
    },
  });
};

export const useSignout = () => {
  const { reset } = usePersonStore();

  return useMutation({
    mutationFn: () => logoutUserFn(),
    onSuccess: (data) => {
      queryClient.clear();
      clearStoreage();
      reset();
    },
  });
};

export default useSignIn;
